import axios from "./axios";
import { createApp } from "vue";

import { createPinia } from "pinia";
import App from "./App.vue";
import router from "./router";
import directive from "./directive";
import store from "./store";
import "./assets/css/common.css";
import "./assets/css/contents.css";
import VueSweetalert2 from "vue-sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";
import { vue3Spinner } from "vue3-spinner";

import { use } from "echarts/core";
import { CanvasRenderer } from "echarts/renderers";
import { PieChart } from "echarts/charts";
import {
  TitleComponent,
  TooltipComponent,
  LegendComponent,
} from "echarts/components";
import VChart from "vue-echarts";
use([
  CanvasRenderer,
  PieChart,
  TitleComponent,
  TooltipComponent,
  LegendComponent,
]);

let app = createApp(App);
directive(app);
app.config.devtools = true;
app.use(store);
app.use(router);
app.use(createPinia());
app.use(vue3Spinner);
app.use(VueSweetalert2);

app.provide("swalAlert", (text) => {
  return app.config.globalProperties.$swal.fire({
    showCloseButton: true,
    confirmButtonColor: "black",
    confirmButtonText: "확인",
    width: "400px",
    html: text,
  });
});

app.provide("swalConfirm", (text) => {
  return app.config.globalProperties.$swal.fire({
    showCloseButton: true,
    showCancelButton: true,
    confirmButtonColor: "black",
    confirmButtonText: "예",
    cancelButtonText: "아니오",
    width: "400px",
    html: text,
  });
});

app.provide("swalConfirmPw", (text) => {
  return app.config.globalProperties.$swal.fire({
    showCloseButton: true,
    showCancelButton: true,
    confirmButtonColor: "black",
    confirmButtonText: "예(변경)",
    cancelButtonText: "아니오(나중에 변경)",
    width: "400px",
    html: text,
  })
})
app.component("v-chart", VChart);
app.provide("axios", axios);
app.mount("#app");
